/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVmMongo } from '../models/custom-result-of-audit-vm-mongo';
import { CustomResultOfGetTextParserByIdDto } from '../models/custom-result-of-get-text-parser-by-id-dto';
import { CustomResultOfListOfTextParserFormulaModel } from '../models/custom-result-of-list-of-text-parser-formula-model';
import { CustomResultOfPaginatedListOfTextParsersWithPaginationDto } from '../models/custom-result-of-paginated-list-of-text-parsers-with-pagination-dto';
import { textParsersCreateGet } from '../fn/text-parsers/text-parsers-create-get';
import { TextParsersCreateGet$Params } from '../fn/text-parsers/text-parsers-create-get';
import { textParsersCreatePost } from '../fn/text-parsers/text-parsers-create-post';
import { TextParsersCreatePost$Params } from '../fn/text-parsers/text-parsers-create-post';
import { textParsersDelete } from '../fn/text-parsers/text-parsers-delete';
import { TextParsersDelete$Params } from '../fn/text-parsers/text-parsers-delete';
import { textParsersGetTextParserAudits } from '../fn/text-parsers/text-parsers-get-text-parser-audits';
import { TextParsersGetTextParserAudits$Params } from '../fn/text-parsers/text-parsers-get-text-parser-audits';
import { textParsersGetTextParserFormulaById } from '../fn/text-parsers/text-parsers-get-text-parser-formula-by-id';
import { TextParsersGetTextParserFormulaById$Params } from '../fn/text-parsers/text-parsers-get-text-parser-formula-by-id';
import { textParsersGetTextParsersWithPagination } from '../fn/text-parsers/text-parsers-get-text-parsers-with-pagination';
import { TextParsersGetTextParsersWithPagination$Params } from '../fn/text-parsers/text-parsers-get-text-parsers-with-pagination';
import { textParsersUpdateGet } from '../fn/text-parsers/text-parsers-update-get';
import { TextParsersUpdateGet$Params } from '../fn/text-parsers/text-parsers-update-get';
import { textParsersUpdateIsChildrenChange } from '../fn/text-parsers/text-parsers-update-is-children-change';
import { TextParsersUpdateIsChildrenChange$Params } from '../fn/text-parsers/text-parsers-update-is-children-change';
import { textParsersUpdatePut } from '../fn/text-parsers/text-parsers-update-put';
import { TextParsersUpdatePut$Params } from '../fn/text-parsers/text-parsers-update-put';

@Injectable({ providedIn: 'root' })
export class TextParsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `textParsersCreateGet()` */
  static readonly TextParsersCreateGetPath = '/TextParsers/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersCreateGet$Response(params?: TextParsersCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return textParsersCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersCreateGet(params?: TextParsersCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.textParsersCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `textParsersCreatePost()` */
  static readonly TextParsersCreatePostPath = '/TextParsers/Create';

  /**
   * Create Text Parser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersCreatePost$Response(params: TextParsersCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return textParsersCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Text Parser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersCreatePost(params: TextParsersCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.textParsersCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `textParsersUpdateGet()` */
  static readonly TextParsersUpdateGetPath = '/TextParsers/Update';

  /**
   * Get Text Parser By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersUpdateGet$Response(params?: TextParsersUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetTextParserByIdDto>> {
    return textParsersUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Text Parser By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersUpdateGet(params?: TextParsersUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetTextParserByIdDto> {
    return this.textParsersUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetTextParserByIdDto>): CustomResultOfGetTextParserByIdDto => r.body)
    );
  }

  /** Path part for operation `textParsersUpdatePut()` */
  static readonly TextParsersUpdatePutPath = '/TextParsers/Update';

  /**
   * Update Text Parser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersUpdatePut$Response(params: TextParsersUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return textParsersUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Text Parser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersUpdatePut(params: TextParsersUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.textParsersUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `textParsersGetTextParserFormulaById()` */
  static readonly TextParsersGetTextParserFormulaByIdPath = '/TextParsers/GetTextParserFormulaById';

  /**
   * دریافت فرمول های تحلیلگر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersGetTextParserFormulaById()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersGetTextParserFormulaById$Response(params?: TextParsersGetTextParserFormulaById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfTextParserFormulaModel>> {
    return textParsersGetTextParserFormulaById(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت فرمول های تحلیلگر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersGetTextParserFormulaById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersGetTextParserFormulaById(params?: TextParsersGetTextParserFormulaById$Params, context?: HttpContext): Observable<CustomResultOfListOfTextParserFormulaModel> {
    return this.textParsersGetTextParserFormulaById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfTextParserFormulaModel>): CustomResultOfListOfTextParserFormulaModel => r.body)
    );
  }

  /** Path part for operation `textParsersUpdateIsChildrenChange()` */
  static readonly TextParsersUpdateIsChildrenChangePath = '/TextParsers/UpdateIsChildrenChange';

  /**
   * Update IsChildrenChange Field.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersUpdateIsChildrenChange()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersUpdateIsChildrenChange$Response(params: TextParsersUpdateIsChildrenChange$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return textParsersUpdateIsChildrenChange(this.http, this.rootUrl, params, context);
  }

  /**
   * Update IsChildrenChange Field.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersUpdateIsChildrenChange$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersUpdateIsChildrenChange(params: TextParsersUpdateIsChildrenChange$Params, context?: HttpContext): Observable<CustomResult> {
    return this.textParsersUpdateIsChildrenChange$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `textParsersDelete()` */
  static readonly TextParsersDeletePath = '/TextParsers/Delete';

  /**
   * Delete Text Parser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersDelete$Response(params?: TextParsersDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return textParsersDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Text Parser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  textParsersDelete(params?: TextParsersDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.textParsersDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `textParsersGetTextParsersWithPagination()` */
  static readonly TextParsersGetTextParsersWithPaginationPath = '/TextParsers/GetTextParsersWithPagination';

  /**
   * Get Text Parsers With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersGetTextParsersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersGetTextParsersWithPagination$Response(params: TextParsersGetTextParsersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfTextParsersWithPaginationDto>> {
    return textParsersGetTextParsersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Text Parsers With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersGetTextParsersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersGetTextParsersWithPagination(params: TextParsersGetTextParsersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfTextParsersWithPaginationDto> {
    return this.textParsersGetTextParsersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfTextParsersWithPaginationDto>): CustomResultOfPaginatedListOfTextParsersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `textParsersGetTextParserAudits()` */
  static readonly TextParsersGetTextParserAuditsPath = '/TextParsers/GetTextParserAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textParsersGetTextParserAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersGetTextParserAudits$Response(params: TextParsersGetTextParserAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVmMongo>> {
    return textParsersGetTextParserAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textParsersGetTextParserAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textParsersGetTextParserAudits(params: TextParsersGetTextParserAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVmMongo> {
    return this.textParsersGetTextParserAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVmMongo>): CustomResultOfAuditVmMongo => r.body)
    );
  }

}
